import { publicAxios } from '@/lib/axios';
import { buildRegisterPayload, type RegisterPayloadInput } from './buildRegisterPayload';

/**
 * Posts a new-user registration to the backend. Thin I/O wrapper around the
 * pure `buildRegisterPayload`; shared by `Register.tsx` and
 * `LoginRegisterModal.tsx`. Throws the underlying axios error on failure so
 * callers can run it through `normalizeRegisterError`.
 */
export async function registerUser(input: RegisterPayloadInput): Promise<void> {
  await publicAxios.post('/api/auth/local/register', buildRegisterPayload(input));
}
